var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorPage"},[_c('p',{attrs:{"id":"message"}},[_vm._v("ログインの有効期間が切れました。")]),_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.onReLogin}},[_vm._v("再ログイン")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }